import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

//CREATE PRODUCT

export const addToCartApi = async (data) => {
  console.log("cart form data ---- ", data);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}vancouverapis/webapp/cart/api/v1/add-item-cart`, data, {
      headers: {
        "auth-token": token,
      },
    });
    console.log("add to cart response ", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    throw error; // Return the error for further handling
  }
};

// delte product from cart

export const deleteFromCartApi = createAsyncThunk("client/delete-from-cart", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}vancouverapis/webapp/cart/api/v1/cart-product-remove`, data, {
      headers: {
        "auth-token": token,
      },
    });
    console.log("delete from cart response ", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "error in delete from cart product");
  }
});

// clear cart api

export const clearCartApi = createAsyncThunk("client/clear-cart", async (_, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");
  const rowid = localStorage.getItem("customerId");

  try {
    const response = await axios.post(
      `${baseUrl}vancouverapis/webapp/cart/api/v1/clear-cart/${rowid}`,

      {
        headers: {
          "auth-token": token,
        },
      }
    );
    console.log("clear cart response ", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "error in clear cart");
  }
});

// update cart product details

export const updateCartProductApi = createAsyncThunk("client/cart-update", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.put(`${baseUrl}vancouverapis/webapp/cart/api/v1/cart-update`, data, {
      headers: {
        "auth-token": token,
      },
    });
    console.log("update cart product response ", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "error in update cart product");
  }
});
